<template>
  <div
    class="h-[60px] w-full pl-6 pr-5 won-background-dark flex items-center justify-between"
  >
    <div class="flex items-center">
      <div
        class="w-8 h-8 rounded-md won-background-dark-200 mr-6 flex items-center justify-center cursor-pointer"
        @click.prevent="handleBack"
      >
        <arrow-back />
      </div>

      <input
        ref="resumeInput"
        v-model="title"
        class="w-fit min-w-[260px] h-8 px-2 pdf-input"
        @keypress.enter="(el) => el.target.blur()"
        @blur.stop="handleTitle"
        @focus="selectContent"        
      />

      <saved-resume v-show="saved" class="ml-4" />
    </div>

    <div class="flex items-center gap-2">
        <ResumeShareBtn
          v-if="isShareResumeEnabled() || isEmailInDomain('@wonsulting.com')"
        />
        
        <DownloadButton
            :idOnboarding="isOnboarding"
            :loadingDownload="loadingDownload"
            :onboardingStep="onboardingStep"
            @download="(docType) => handleDownload(docType)"
        />
      
      <button @click="handleTailorResume" v-if="isTailorTargetButtonEnabled() && !coverLetter && getCurrentVersion() >= 6" :disbled="builderBulletPoints < 2" v-tooltip="{content: builderBulletPoints < 2 ? 'Need more than 1 bullet point' : ''}" :class="[{'border-[#686E77]': builderBulletPoints < 2, 'border-white': builderBulletPoints >= 2}, 'border ml-2 py-1.5 px-6 rounded flex items-center justify-center']">
          <svg width="20" height="20" viewBox="0 0 20 20" :class="['fill-current', {'text-[#686E77]': builderBulletPoints < 2, 'text-white': builderBulletPoints >= 2}]" xmlns="http://www.w3.org/2000/svg">          <path d="M10.1802 10.3872L10.1802 10.3872L10.499 10.5001V10.6001C10.4991 10.6001 10.4991 10.6001 10.4991 10.6001C10.5906 10.6 10.6785 10.5636 10.7431 10.4988L10.7431 10.4988L10.7443 10.4976L17.4989 3.48842C17.6329 3.35356 17.6327 3.13563 17.4982 3.00111C17.3634 2.86636 17.145 2.86641 17.0102 3.00107L17.0102 3.00106L17.0088 3.00243L10.2543 10.0118C10.1562 10.1105 10.1269 10.2585 10.1802 10.3872Z" stroke-width="0.2"/>          <path d="M8.31211 12.5321C8.20307 12.5319 8.10061 12.4801 8.03588 12.3924C7.97116 12.3046 7.95183 12.1913 7.98404 12.0872L8.8859 9.17591C8.92149 9.06087 9.01474 8.97284 9.13161 8.944C9.24848 8.91502 9.37195 8.94937 9.45708 9.0345L11.4662 11.0431C11.5513 11.1282 11.5856 11.2517 11.5566 11.3686C11.5278 11.4854 11.4398 11.5787 11.3247 11.6143L8.41396 12.5161C8.38098 12.5264 8.34678 12.5318 8.31212 12.5321L8.31211 12.5321ZM9.37162 9.92318L8.83142 11.6677L10.5775 11.129L9.37162 9.92318Z" />          <path d="M8.31211 12.5321C8.20307 12.5319 8.10061 12.4801 8.03588 12.3924C7.97116 12.3046 7.95183 12.1913 7.98404 12.0872L8.8859 9.17591C8.92149 9.06087 9.01474 8.97284 9.13161 8.944C9.24848 8.91502 9.37195 8.94937 9.45708 9.0345L11.4662 11.0431C11.5513 11.1282 11.5856 11.2517 11.5566 11.3686C11.5278 11.4854 11.4398 11.5787 11.3247 11.6143L8.41396 12.5161C8.38098 12.5264 8.34678 12.5318 8.31212 12.5321L8.31211 12.5321ZM9.37162 9.92318L8.83142 11.6677L10.5775 11.129L9.37162 9.92318Z"/>          <path d="M15.2423 5.60144C15.1486 5.60159 15.059 5.5634 14.9941 5.49591C14.9293 5.42843 14.8949 5.33732 14.8987 5.24376L15.0078 2.61168C15.0113 2.52564 15.047 2.44404 15.1078 2.38315L16.8888 0.602163C16.9852 0.504155 17.1309 0.473019 17.259 0.523328C17.3872 0.57348 17.473 0.695262 17.4771 0.832841L17.5514 2.94883L19.6673 3.02352C19.804 3.02828 19.9249 3.11371 19.975 3.24086C20.0252 3.36816 19.9951 3.51295 19.8983 3.60973L18.117 5.39056C18.0561 5.45145 17.9745 5.48718 17.8885 5.49071L15.2564 5.60114L15.2423 5.60144ZM15.6901 2.77441L15.6012 4.89896L17.7257 4.81L18.8539 3.68221L17.2251 3.6247H17.225C17.0378 3.61105 16.8891 3.46227 16.8754 3.27516L16.8179 1.64632L15.6901 2.77441Z" />          <path d="M15.2423 5.60144C15.1486 5.60159 15.059 5.5634 14.9941 5.49591C14.9293 5.42843 14.8949 5.33732 14.8987 5.24376L15.0078 2.61168C15.0113 2.52564 15.047 2.44404 15.1078 2.38315L16.8888 0.602163C16.9852 0.504155 17.1309 0.473019 17.259 0.523328C17.3872 0.57348 17.473 0.695262 17.4771 0.832841L17.5514 2.94883L19.6673 3.02352C19.804 3.02828 19.9249 3.11371 19.975 3.24086C20.0252 3.36816 19.9951 3.51295 19.8983 3.60973L18.117 5.39056C18.0561 5.45145 17.9745 5.48718 17.8885 5.49071L15.2564 5.60114L15.2423 5.60144ZM15.6901 2.77441L15.6012 4.89896L17.7257 4.81L18.8539 3.68221L17.2251 3.6247H17.225C17.0378 3.61105 16.8891 3.46227 16.8754 3.27516L16.8179 1.64632L15.6901 2.77441Z"/>          <path d="M9.03901 4.18734H9.11391C13.0904 4.22766 16.3129 7.47514 16.3127 11.4612C16.3127 15.4724 13.0501 18.7359 9.03901 18.7359C5.02792 18.7359 1.76454 15.4721 1.76454 11.4612C1.76454 7.45035 5.02802 4.18734 9.03901 4.18734ZM0.9 11.4612C0.9 15.9493 4.55112 19.6004 9.03901 19.6004C13.5269 19.6004 17.1777 15.9469 17.1777 11.4612C17.1777 6.97562 13.5269 3.32264 9.03901 3.32279C4.5511 3.32279 0.9 6.97319 0.9 11.4612Z"  stroke-width="0.2"/>          <path d="M5.39548 7.7288C4.38924 8.67897 3.82285 9.969 3.82285 11.3155C3.82285 12.6619 4.38924 13.952 5.39548 14.9021C6.40135 15.8521 7.7645 16.3849 9.18463 16.3849L9.18477 16.3849C10.6043 16.3829 11.9664 15.8495 12.9717 14.9C13.9774 13.9502 14.5445 12.6614 14.5464 11.3156V11.3155C14.5464 9.969 13.98 8.67898 12.974 7.7288C11.9681 6.77881 10.6049 6.24601 9.18463 6.24601C7.7645 6.24601 6.40135 6.77881 5.39548 7.7288ZM5.39548 7.7288L5.46414 7.8015L5.39548 7.7288ZM9.18463 7.16901H9.28658L9.28656 7.16799C10.4172 7.19422 11.4946 7.63004 12.2945 8.38583L12.3632 8.31315L12.2945 8.38583C13.1182 9.16399 13.5801 10.2179 13.5811 11.3157C13.581 12.4134 13.1193 13.4676 12.2954 14.2457C11.4713 15.0241 10.3525 15.4623 9.18463 15.4623C8.01694 15.4623 6.89795 15.0241 6.07384 14.2457C5.24993 13.4676 4.7882 12.4134 4.7882 11.3156C4.7882 10.2179 5.24993 9.16366 6.07384 8.38552C6.89795 7.60719 8.0169 7.16901 9.18463 7.16901Z"  stroke-width="0.2"/>          </svg>
          <span :class="[{'text-[#686E77]': builderBulletPoints < 2, 'text-white': builderBulletPoints >= 2}, 'font-medium text-sm pl-1.5 font-[Roboto]']">Target</span>
      </button>

      <Menu as="div" class="relative inline-block text-left resume-settings">
        <div>
          <MenuButton class="flex items-center justify-center cursor-pointer rounded select-none h-[32px] w-[32px] py-[10px] px-[8px] bg-[#b6dbc4]">
            <svg class="stroke-2 w-4 h-4 text-[#073B5D]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_201_11008)"> <path d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z" fill="#073B5D"/> </g> <defs> <clipPath id="clip0_201_11008"> <rect width="24" height="24" fill="white"/> </clipPath> </defs> </svg>
          </MenuButton>
        </div>
    
        <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
          <MenuItems class="absolute right-0 z-10 mt-2 w-[90px] origin-top-right rounded bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div class="py-1">
              <MenuItem v-slot="{ active }">   
                <a @click="duplicateResume" :class="[active ? 'bg-[#F4F4F4]' : '', 'cursor-pointer block px-2 py-1 leading-[14px] font-normal text-[12px] flex items-center justify-start text-[#073B5D]']">
                  <svg class="stroke-2 w-4 h-4 text-[#073B5D] mr-1" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_1_8267)"> <path d="M10.6666 0.666504H2.66659C1.93325 0.666504 1.33325 1.2665 1.33325 1.99984V11.3332H2.66659V1.99984H10.6666V0.666504ZM12.6666 3.33317H5.33325C4.59992 3.33317 3.99992 3.93317 3.99992 4.6665V13.9998C3.99992 14.7332 4.59992 15.3332 5.33325 15.3332H12.6666C13.3999 15.3332 13.9999 14.7332 13.9999 13.9998V4.6665C13.9999 3.93317 13.3999 3.33317 12.6666 3.33317ZM12.6666 13.9998H5.33325V4.6665H12.6666V13.9998Z" fill="#073B5D"/> </g> <defs> <clipPath id="clip0_1_8267"> <rect width="16" height="16" fill="white"/> </clipPath> </defs> </svg>
                  Duplicate
                </a>
              </MenuItem>
              <MenuItem v-slot="{ active }">   
                <a @click="renameResume" :class="[active ? 'bg-[#F4F4F4]' : '', 'cursor-pointer block px-2 py-1 leading-[14px] font-normal text-[12px] flex items-center justify-start text-[#073B5D]']">
                  <svg class="stroke-2 w-4 h-4 text-[#073B5D] mr-1" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_1_8270)"> <path d="M12.2733 3.86659L11.4667 3.05992C10.9467 2.53992 10.1 2.53992 9.58 3.05992L7.79333 4.84659L2 10.6399V13.3333H4.69333L10.52 7.50659L12.2733 5.75326C12.8 5.23326 12.8 4.38659 12.2733 3.86659ZM4.14 11.9999H3.33333V11.1933L9.10667 5.41992L9.91333 6.22659L4.14 11.9999ZM7.33333 13.3333L10 10.6666H14V13.3333H7.33333Z" fill="#073B5D"/> </g> <defs> <clipPath id="clip0_1_8270"> <rect width="16" height="16" fill="white"/> </clipPath> </defs> </svg>
                  Rename
                </a>
              </MenuItem>
              <MenuItem v-slot="{ active }">   
                <a @click="deleteResume" :class="[active ? 'bg-[#F4F4F4]' : '', 'cursor-pointer block px-2 py-1 leading-[14px] font-normal text-[12px] flex items-center justify-start text-[#073B5D] delete-resume-btn']">
                  <svg class="stroke-2 w-4 h-4 text-[#073B5D] mr-1" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_1_8273)"> <path d="M3.99992 12.6667C3.99992 13.4 4.59992 14 5.33325 14H10.6666C11.3999 14 11.9999 13.4 11.9999 12.6667V4.66667H3.99992V12.6667ZM12.6666 2.66667H10.3333L9.66659 2H6.33325L5.66659 2.66667H3.33325V4H12.6666V2.66667Z" fill="#073B5D"/> </g> <defs> <clipPath id="clip0_1_8273"> <rect width="16" height="16" fill="white"/> </clipPath> </defs> </svg>
                  Delete
                </a>
              </MenuItem>
            </div>
          </MenuItems> 
        </transition>
      </Menu>
    </div>

    <delete-modal
      :key="deleteVisible"
      :visible="deleteVisible"
      :title="`Delete \`${title || 'Title'}\``"
      :loading="loadingDelete"
      subtitle="Are you sure you want to delete this resume?"
      @delete-modal:close="handleCloseDelete"
      @delete-modal:confirm="handleDeleteConfirm"
    />
  </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouter, useRoute } from 'vue-router';
import { getCurrentVersion } from '../../utils/helpers';
import { extractContent, isTailorTargetButtonEnabled,  } from '../../utils/helpers';
import { isShareResumeEnabled } from "../../utils/feature-flags";
import {setAuthState} from "../../composables/auth";

import { useBuilder } from '../../store/builder.store';
import { useOnboardingStore } from '../../store/onboarding.store';
import { useNotifications } from "../../store/notifications.store";
import { useServicesNudges } from '../../store/services-nudges.store';
import { useOnboardingChecklist } from "../../store/onboarding-checklist.store";
import { useResumesStore } from '../../store/resumes.store.js';
import { useCoverLettersStore } from "../../store/cover-letters.store";

import {
    createResume
} from '../../api/builder';
import {
    createCoverLetter, retrieveCoverLetter
} from '../../api/cover-letters';

import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import DeleteModal from '../../modals/delete-modal.vue';
import DownloadButton from './components/download-button.vue';
import ResumeShareBtn from '../resume-tool/share-resume-btn.vue';

import ArrowBack from '../../icons/arrow-back';
import SavedResume from '../../icons/pdf-saved';

const emit = defineEmits(['download', 'tailor-resume']);
const { isEmailInDomain } = setAuthState();

const router = useRouter()
const route = useRoute()

const builder = useBuilder()
builder.activeRoute = useRoute()

const resumesStore = useResumesStore();
const coverLettersStore = useCoverLettersStore();
const notificationsStore = useNotifications();

const servicesNudgesStore = useServicesNudges();

const { meta: { coverLetter = false } } = useRoute()

const onboardingStore = useOnboardingStore()
const { isOnboarding, onboardingStep } = storeToRefs(onboardingStore)

const { data, saved, loaded, bulletPoints, isDocumentEditable } = storeToRefs(builder)

const notificationStore = useNotifications();
const onboardingChecklist = useOnboardingChecklist();

const builderBulletPoints = computed(() => {
  if(! loaded.value) return 0
  return bulletPoints.value.length
})

const title = ref('')
const resumeInput = ref('')

const deleteVisible = ref(false)
const loadingDelete = ref(false)
const loadingDownload = ref(false)

watch(loaded, () => {
  if (loaded.value) {
    title.value = extractContent(data.value.title)
  }
})

watch(
  () => route.params.id,
  async newId => {
    if(newId) builder.init(newId, router, route)
  }
)

const handleTailorResume = () => {
  emit('tailor-resume')
}

const handleDownload = async (type) => {
  await servicesNudgesStore.showNudgeModalFor(servicesNudgesStore.FEATURES.resumeAi);

  loadingDownload.value = true

  await builder.download(null, type)

  notificationStore.notify('Your download is ready!')
  loadingDownload.value = false

  emit('download', {type})  
}

const duplicateResume = async() => {
  const result = coverLetter
    ? await retrieveCoverLetter(route.params.id)
    : builder.data
    
  const parsed = builder.buildData(result)

  const data = {
    ...parsed,
    title: parsed.title + ' - Copy',
    id: undefined,
  }

  if(coverLetter) {
    createCoverLetter(data).then(res => {
    router.push({
        name: "cover-letters.edit",
        params: { id: res.uuid  }
    });
  })
  } else {
    createResume(data).then(res => {
    router.push({
        name: "resumes.edit",
        params: { id: res.uuid  }
    });
  })
  }
}

const renameResume = () => {
  setTimeout(() => resumeInput.value.focus(), 100)
}

const deleteResume = () => {
  deleteVisible.value = true
}

const handleDeleteConfirm = async () => {
  loadingDelete.value = true

  try {
    if(coverLetter) {
      await coverLettersStore.deleteCoverLetter(route.params.id);
    }else{
      await resumesStore.deleteResume(route.params.id);
    }

    router.push({ name: 'home' })
  }catch (e) {
    notificationsStore.notify(`Failed to delete ${coverLetter ? 'cover letter' : 'resume'}!`, 'error')
  }finally {
    handleCloseDelete();
    loadingDelete.value = false
  }
}

const handleCloseDelete = () => {
  deleteVisible.value = false
}

const handleBack = () => {
  router.back()
}

const handleTitle = () => {
  builder.changeTitle(title)
}

const selectContent = (e) => {
  e.target.select()
}
</script>

<style>
.pdf-input {
  background-color: #363f4b;
  border-radius: 6px;

  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #ffffff;

  outline: none !important;
}
</style>
